import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

/**
 * Emits when a click occurs outside the host element.
 * Handles edge cases for CDK overlays (detached elements and overlay containers).
 */
@Directive({
  selector: '[motnClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output() motnClickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: HTMLElement): void {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    const inOverlay = (target as Element).closest('.cdk-overlay-container');
    const isDetached = !document.body.contains(target);

    if (!clickedInside && !inOverlay && !isDetached) {
      this.motnClickOutside.emit();
    }
  }
}
